import { render, staticRenderFns } from "./Phase1Container.vue?vue&type=template&id=2a4bc7a5&scoped=true&"
import script from "./Phase1Container.vue?vue&type=script&lang=js&"
export * from "./Phase1Container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4bc7a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
